import OriginalAnswerItem from '../../../api/v2/models/answer_item'
import EditorAnswerItem from '../../../../common/AnswerItem'
import { AnswerChangeLog } from './ChangeLog';
import { CHANGE_TYPE } from '../../../api/v2/forms/exam_comparison';
import { AnswerForm } from '../../../api/v2/forms/exam_comparison';

export default class AnswerItemComparison {
    readonly isSameCorrect: boolean = false
    readonly isSameAllotment: boolean = false
    readonly isSameName: boolean = false
    readonly isSameBody: boolean = false
    constructor(readonly originalAnswerItem: OriginalAnswerItem | null, readonly editorAnswerItem: EditorAnswerItem | null) {
        if (originalAnswerItem && editorAnswerItem) {
            // Normalize representation gaps: DB stores allotment as 0 / correct as boolean,
            // while the body parser yields undefined allotment for unscored answers.
            // Without normalizing, every unscored answer would falsely compare as changed.
            this.isSameCorrect = Boolean(originalAnswerItem.correct) == Boolean(editorAnswerItem.correct)
            this.isSameAllotment = (originalAnswerItem.allotment || 0) == (editorAnswerItem.allotment || 0)
            this.isSameName = originalAnswerItem.name == editorAnswerItem.name
            this.isSameBody = originalAnswerItem.body == editorAnswerItem.body
        }
    }

    get isSame(){
        return this.isSameAllotment && this.isSameBody && this.isSameCorrect && this.isSameName
    }

    get changeLogs() : AnswerChangeLog[] {
        let changelogs = []
        if (!this.editorAnswerItem) {
            changelogs.push(new AnswerChangeLog(CHANGE_TYPE.Delete, "アンサー削除", this.originalAnswerItem.body, ""))
            return changelogs
        }
        if (!this.originalAnswerItem) {
            changelogs.push(new AnswerChangeLog(CHANGE_TYPE.Create, "アンサー追加", "", this.editorAnswerItem.body))
            return changelogs
        }

        if (!this.isSameName) {
            changelogs.push(new AnswerChangeLog(CHANGE_TYPE.Update, "アンサーの名前", this.originalAnswerItem.name, this.editorAnswerItem.name))
        }
        if (!this.isSameBody) {
            changelogs.push(new AnswerChangeLog(CHANGE_TYPE.Update, "アンサーの内容", this.originalAnswerItem.body, this.editorAnswerItem.body))
        }
        if (!this.isSameCorrect) {
            changelogs.push(new AnswerChangeLog(CHANGE_TYPE.Update, "アンサーの結果", this.originalAnswerItem.correct ? "TRUE" : "FALSE", this.editorAnswerItem.correct ? "TRUE" : "FALSE"))
        }
        if (!this.isSameAllotment) {
            changelogs.push(new AnswerChangeLog(CHANGE_TYPE.Update, "アンサーの点数", this.originalAnswerItem.allotment, this.editorAnswerItem.allotment))
        }

        return changelogs
    }

    get form() : AnswerForm{
        const answerForm = new AnswerForm()

        if (!this.editorAnswerItem) {
            answerForm.changeType = CHANGE_TYPE.Delete
            answerForm.id = this.originalAnswerItem.id
            return answerForm
        }

        answerForm.allotment = this.editorAnswerItem.allotment ? this.editorAnswerItem.allotment : 0
        answerForm.body = this.editorAnswerItem.body
        answerForm.correct = this.editorAnswerItem.correct
        answerForm.name = this.editorAnswerItem.name
        answerForm.scopeId = this.editorAnswerItem.scopeId

        if (!this.originalAnswerItem) {
            answerForm.changeType = CHANGE_TYPE.Create
        } else {
            answerForm.changeType = CHANGE_TYPE.Update
            answerForm.id = this.originalAnswerItem.id
        }

        return answerForm
    }
}